module.exports = __webpack_public_path__ + "img/65RBayberryAve_Small.f2621fbc.png";